import { fromMarkdown } from 'mdast-util-from-markdown'

const createUid = () => {
  return `mm_${Date.now().toString(36)}_${Math.random().toString(36).substring(2, 8)}`
}

const getNodeText = node => {
  // 优先找出其中的text类型的子节点
  let textChild = (node.children || []).find(item => {
    return item.type === 'text'
  })
  // 没有找到，那么直接使用第一个子节点
  textChild = textChild || node.children[0]
  if (textChild) {
    if (textChild.value !== undefined) {
      return textChild.value
    }
    return getNodeText(textChild)
  }
  return ''
}

// 处理list的情况
const handleList = node => {
  let list = []
  let walk = (arr, newArr) => {
    for (let i = 0; i < arr.length; i++) {
      let cur = arr[i]
      let node = {}
      node.data = {
        // 节点内容
        text: getNodeText(cur)
      }
      node.children = []
      newArr.push(node)
      if (cur.children.length > 1) {
        for (let j = 1; j < cur.children.length; j++) {
          let cur2 = cur.children[j]
          if (cur2.type === 'list') {
            walk(cur2.children, node.children)
          }
        }
      }
    }
  }
  walk(node.children, list)
  return list
}

// 将markdown转换成节点树
export const transformMarkdownTo = (md,id) => {
  const tree = fromMarkdown(md);
  console.log(tree, md);

  let root = {
    data: {
      text: "Mind map",
    },
    uid:id,
    children: [],
  };

  let childrenQueue = [root.children];
  let currentChildren = root.children;
  let depthQueue = [-1];
  let currentDepth = -1;
  let hasH1 = false;

  for (let i = 0; i < tree.children.length; i++) {
    let cur = tree.children[i];

    if (cur.type === "heading") {
      if (!cur.children[0]) continue;

      // 检查是否有H1标题
      if (cur.depth === 1) {
        hasH1 = true;
      }

      // 创建新节点
      let node = {
        data: {
          text: getNodeText(cur),
        },
        uid:id,
        children: [],
      };

      // 处理深度变化
      if (cur.depth > currentDepth) {
        // 当前深度大于上一个深度，添加为子节点
        currentChildren.push(node);
        childrenQueue.push(node.children);
        currentChildren = node.children;
        depthQueue.push(cur.depth);
        currentDepth = cur.depth;
      } else if (cur.depth === currentDepth) {
        // 当前深度等于上一个深度，添加为同级节点
        childrenQueue.pop();
        currentChildren = childrenQueue[childrenQueue.length - 1];
        depthQueue.pop();
        currentDepth = depthQueue[depthQueue.length - 1];

        currentChildren.push(node);
        childrenQueue.push(node.children);
        currentChildren = node.children;
        depthQueue.push(cur.depth);
        currentDepth = cur.depth;
      } else {
        // 当前深度小于上一个深度，需要回退到合适的父节点
        while (
          depthQueue.length > 1 &&
          depthQueue[depthQueue.length - 1] >= cur.depth
        ) {
          childrenQueue.pop();
          currentChildren = childrenQueue[childrenQueue.length - 1];
          depthQueue.pop();
          currentDepth = depthQueue[depthQueue.length - 1];
        }

        // 如果当前深度比栈中最小的深度还小，添加为根节点的子节点
        if (cur.depth < depthQueue[depthQueue.length - 1]) {
          root.children.push(node);
          childrenQueue = [root.children, node.children];
          currentChildren = node.children;
          depthQueue = [-1, cur.depth];
          currentDepth = cur.depth;
        } else {
          currentChildren.push(node);
          childrenQueue.push(node.children);
          currentChildren = node.children;
          depthQueue.push(cur.depth);
          currentDepth = cur.depth;
        }
      }
    } else if (cur.type === "list") {
      currentChildren.push(...handleList(cur));
    }
  }

  // 如果没有H1标题，使用默认标题
  if (!hasH1) {
    return root;
  }

  return root.children[0] || root;
};

